import React from 'react';
import { 
  HelpCircle, 
  Clock, 
  Server, 
  Code, 
  Globe, 
  Terminal, 
  Info, 
  AlertTriangle 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по Unix-времени
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Clock,
      title: 'Что такое Unix-время?',
      description: 'Количество секунд, прошедших с 1 января 1970 года 00:00:00 UTC (Epoch).'
    },
    {
      icon: Server,
      title: '32-битное ограничение',
      description: '32-битные системы достигнут предела (год 2038) при значении 2,147,483,647.'
    },
    {
      icon: Code,
      title: 'Миллисекунды в JavaScript',
      description: 'В JavaScript Date.now() возвращает timestamp в миллисекундах, не в секундах.'
    },
    {
      icon: Globe,
      title: 'Часовые пояса',
      description: 'Unix-время всегда в UTC. Для локального времени нужно учитывать смещение часового пояса.'
    },
    {
      icon: Terminal,
      title: 'Команда date в Linux',
      description: 'Получить текущий timestamp: date +%s, преобразовать timestamp: date -d @1625097600'
    },
    {
      icon: Info,
      title: 'Y2K38 проблема',
      description: 'В 2038 году (03:14:07 UTC 19 января) произойдет переполнение 32-битного таймера Unix.'
    },
    {
      icon: AlertTriangle,
      title: 'Високосные секунды',
      description: 'Unix-время не учитывает високосные секунды, добавляемые для синхронизации с вращением Земли.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-cyan-500" />
        Советы по Unix-времени
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-cyan-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-100 dark:border-cyan-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-cyan-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-cyan-700 dark:text-cyan-300 mb-2">
              Использование в программировании
            </h4>
            <p className="text-xs text-cyan-600 dark:text-cyan-400 mb-3">
              Unix-время широко используется в программировании для хранения временных меток и расчета временных интервалов.
            </p>
            <button className="w-full py-1.5 text-xs bg-cyan-500 text-white rounded hover:bg-cyan-600 transition-colors">
              Подробнее о работе с датами
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TipsSidebar;